// Creates a deep copy of an object passed in. The <T> generic syntax preserves the object type.
// For more information about deep vs.shallow copies, see here:
// https://blog.bitsrc.io/shallow-copy-and-deep-copy-in-javascript-d0ca570cd4cf

export function createDeepCopy<T>(objectToCopy: T): T {
  return JSON.parse(JSON.stringify(objectToCopy));
}
